<template>
  <div>
    <Modal
      v-model="pdmodal"
      :title="$t('PB_Select_Employee_Search')"
      width="80%"
      :closable="false"
      :mask-closable="false"
      ><!-- 选择员工 -->
      <Form :model="modalFormItem" :label-width="100">
        <Row :gutter="10">
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('BU')"
              ><!-- 业务单元 -->
              <Select
                v-model="modalFormItem.businessUnit"
                clearable
                style="width:100%"
              >
                <Option
                  v-for="item in businessUnitList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ item.ch_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Funciton')"
              ><!-- 职能 -->
              <Select
                v-model="modalFormItem.postFun"
                clearable
                style="width:100%"
              >
                <Option
                  v-for="item in functionList"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ item.ch_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Management_Level')"
              ><!-- 管理层级 -->
              <Select
                v-model="modalFormItem.hrmanage"
                clearable
                style="width:100%"
              >
                <Option
                  v-for="item in Level"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ item.ch_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Position')"
              ><!-- 职位 -->
              <Input v-model="modalFormItem.position" />
              <!-- <Select v-model="modalFormItem.position" clearable style="width:100%">
                <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
                </Select> -->
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Employee_Code')"
              ><!-- 员工号 -->
              <Input type="text" v-model="modalFormItem.empCode" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Name')"
              ><!-- 姓名 -->
              <Input type="text" v-model="modalFormItem.userName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('English_Name')"
              ><!-- 英文名 -->
              <Input type="text" v-model="modalFormItem.eName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Line_Manager')"
              ><!-- 直接上级 -->
              <Input type="text" v-model="modalFormItem.dirSupName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="6">
            <FormItem :label="$t('Carlsberg_Band')"
              ><!-- 嘉士伯级别 -->
              <Select
                v-model="modalFormItem.hcmBand"
                clearable
                style="width:100%"
              >
                <Option
                  v-for="item in Band"
                  :value="item.ch_value"
                  :key="item.code"
                  >{{ item.ch_value }}</Option
                >
              </Select>
            </FormItem>
          </Col>

          <Col :xs="24" :sm="24" :md="12" :lg="2">
            <FormItem style="display: flex;justify-content: end;">
              <Button @click="getData()"
                ><!-- 检 索 -->{{ $t("Search") }}</Button
              >
            </FormItem>
          </Col>
        </Row>
        <!-- <FormItem label="职能">
            <Select v-model="modalFormItem.code3" style="width:200px">
            <Option v-for="item in list" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
        </FormItem> -->
      </Form>
      <div
        style="display: flex; align-items: center;justify-content: space-between;margin-bottom:10px"
      >
        <div>
          <span>合计：{{ total }}人</span>
          <span style="margin-left:20px" v-if="btnShow"
            >空岗合计：{{ nullJobNum }}个</span
          >
        </div>
        <div>
          <Button type="text" :disabled="beEnd == 1" @click="addPerson(0)"
            >新增人员</Button
          >
          <Button
            v-if="btnShow"
            :disabled="beEnd == 1"
            type="text"
            @click="addJob"
            >新增空岗</Button
          >
        </div>
      </div>
      <Table
        highlight-row
        border
        :columns="modelColumns"
        :data="modelDataa"
        ref="selection"
        :loading="loading"
      >
      </Table>
      <div style="display: flex;justify-content: end;margin-top: 30px;">
        <Page :total="total" @on-change="pageChange"></Page>
      </div>

      <div slot="footer">
        <Button type="text" @click="handleConfirm"
          ><!-- 确认 -->{{ $t("Confirm") }}</Button
        >
        <Button type="text" @click="handleCancle"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="jobmodal"
      :title="$t('Adding_Vacancies')"
      @on-cancel="canceljob"
      ><!-- 追加空岗 -->
      <Form :model="jobFormItem" :label-width="160">
        <FormItem label="空岗是否顶层">
          <Select
            v-model="jobFormItem.beTopLevel"
            style="width:200px"
            placeholder=""
            @on-change="jobChange"
          >
            <Option
              v-for="item in yesOrNo"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
          <Button v-if="jobFormItem.beTopLevel == '1'" @click="addPerson(1)"
            >选择下属</Button
          >
        </FormItem>
        <FormItem label="空岗职位">
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.jobName"
          />
        </FormItem>
        <FormItem label="汇报人">
          <Input
            :disabled="
              jobFormItem.beTopLevel == '1' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            style="width:200px"
            type="text"
            v-model="jobFormItem.userName"
            search
            @on-search="searchUser"
          />
        </FormItem>
        <FormItem :label="$t('BU')"
          ><!-- 业务单元 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            v-model="jobFormItem.businessUnit"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in businessUnitList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Department')"
          ><!-- 大区 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            v-model="jobFormItem.department"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in departmentList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职能"
          ><!-- 职能 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            v-model="jobFormItem.postFun"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in functionList"
              :value="item.code"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职位"
          ><!-- 职位 -->
          <!-- <Select :disabled="jobFormItem.beTopLevel=='0'?true:false" v-model="jobFormItem.position" style="width:200px" placeholder="">
                <Option  v-for="item in positionList" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
            </Select> -->
          <Input
            v-model="jobFormItem.position"
            style="width:200px"
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
          />
        </FormItem>
        <FormItem label="Band">
          <Select v-model="jobFormItem.hcmBand" style="width:200px">
            <Option
              v-for="item in Band"
              :value="item.ch_value"
              :key="item.code"
              >{{ item.ch_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职务描述（中文）"
          ><!-- 职务描述（中文） -->
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.positionCTitle"
          />
        </FormItem>
        <FormItem label="职务描述（英文）"
          ><!-- 职务描述（英文） -->
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.positionETitle"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="savejob"
          ><!-- 确认 -->{{ $t("Confirm") }}</Button
        >
        <Button type="text" @click="canceljob"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <selectPeople ref="selectPeople" @onSelectList="onSelectList" />
    <PDselectPeopleEmp
      ref="PDselectPeopleEmp"
      @onSelect="onSelect"
    ></PDselectPeopleEmp>
  </div>
</template>

<script>
import axios from "axios";
import PDselectPeopleEmp from "./PDselectPeopleEmp.vue";
import selectPeople from "../components/selectPeople";

export default {
  components: { PDselectPeopleEmp, selectPeople },
  data() {
    return {
      loading: false,
      pdmodal: false,
      modalFormItem: {},
      modelDataa: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      list: [],
      positionList: [],
      ApplyStatus: [],
      departmentList: [],
      functionList: [],
      businessUnitList: [],
      Level: [],
      BeQuit: [],
      selectList: [],
      Band: [],
      rowItem: {},
      targetIndex: "",
      userType: "",
      id: "",
      btnShow: false,
      jobmodal: false,
      jobFormItem: {
        userName: "",
        businessUnit: "",
        department: "",
        position: "",
        postFun: ""
      },
      yesOrNo: [],
      nullJobSerialnumberList: [],
      tIndex: "",
      nullJobNum: 0,
      beEnd: 0
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    modelColumns() {
      return [
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Department") /* 大区 */,
          key: "department",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Funciton") /* 职能 */,
          key: "postFun",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "positionCTitle",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  created() {
    // this.getData()
    this.getListData();
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.positionList = res.positionList;
          this.departmentList = res.departmentList;
          this.businessUnitList = res.businessUnitList;
          this.Level = res.ManagementLevel;
          this.Band = res.Band;
          this.functionList = res.functionList;
          this.BeQuit = res.BeQuit;
          this.yesOrNo = res.YesOrNo;
        }
      });
    },
    getData(val) {
      let obj = {
        userType: this.userType,
        id: this.id || val,
        ...this.modalFormItem,
        ...this.pageInfo
      };
      this.loading = true;
      axios.post("/TalentInventory/selectPeoPleBoardPerson", obj).then(res => {
        this.loading = false;
        if (res) {
          this.modelDataa = res.data;
          this.total = parseInt(res.pageInfo.total);
          this.nullJobNum = res.nullJobNum;
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    handleConfirm() {
      this.pdmodal = false;
    },
    handleCancle() {
      this.pdmodal = false;
    },

    onSelectList(list) {
      if (this.tIndex == 1) {
        this.nullJobSerialnumberList = list;
      }
      //   this.modelDataa=list
    },
    addPerson(val) {
      this.tIndex = val;
      if (val == 0) {
        this.$refs.PDselectPeopleEmp.selectList = [...this.modelDataa];
        this.$refs.PDselectPeopleEmp.state = true;
      } else {
        this.$refs.PDselectPeopleEmp.selectList = [
          ...this.nullJobSerialnumberList
        ];
      }
      this.$refs.PDselectPeopleEmp.userType = this.userType;
      this.$refs.PDselectPeopleEmp.id = this.id;
      this.$refs.PDselectPeopleEmp.getData();
      this.$refs.PDselectPeopleEmp.modal = true;

      // this.$refs.peoModal.rowItem=this.rowItem
      // this.$refs.ispeoModal.targetkey=key
    },
    addJob() {
      this.jobmodal = true;
    },
    savejob() {
      if (!this.jobFormItem.beTopLevel) {
        this.jobmodal = true;
        this.$Message.error(this.$t("Emp_Ach_mess19")); //请选择空岗是否顶层
        return;
      }
      let obj = {
        meetingId: this.id,
        ...this.jobFormItem,
        nullJobSerialnumberList: this.nullJobSerialnumberList,
        successorSerialnumberList: [],
        successorLevel: "",
        beNullJob: 1,
        dirSupPosition: ""
      };
      axios.post("/successorInfo/insertSuccessionInfo", obj).then(res => {
        if (res) {
          this.$Message.success(res);
          this.getData(this.id);
          this.jobFormItem = {};
          this.nullJobSerialnumberList = [];
          this.jobmodal = false;
        }
      });
    },
    searchUser() {
      this.$refs.selectPeople.modal = true;
      console.log('当前列：', this.$refs.selectPeople.modelColumns);
      console.log('最后一列：', this.$refs.selectPeople.modelColumns[this.$refs.selectPeople.modelColumns.length - 1]);
      this.$refs.selectPeople.modelColumns.splice(-1, 1);
      this.$refs.selectPeople.modelColumns.unshift({
        title: this.$t("PB_Select_Search") /* 选择 */,
        slot: "action1",
        minWidth: 60,
        align: "center"
      });
    },
    onSelect(item) {
      console.log(item);
      this.jobFormItem.userName = item.userName;
      this.jobFormItem.businessUnit = item.businessUnitCode;
      this.jobFormItem.department = item.departmentCode;
      this.jobFormItem.position = item.positionCode;
      this.jobFormItem.postFun = item.postFunCode;
    },
    canceljob() {
      this.jobmodal = false;
      this.jobFormItem = {
        userName: "",
        businessUnit: "",
        department: "",
        position: "",
        postFun: ""
      };

      this.nullJobSerialnumberList = [];
    },
    jobChange() {
      this.jobFormItem.userName = "";
      this.jobFormItem.businessUnit = "";
      this.jobFormItem.department = "";
      this.jobFormItem.position = "";
      this.jobFormItem.postFun = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PDIsSelectPeople.vue